import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Star, Check } from "lucide-react";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data.reviews));
  useEffect(() => { load(); }, []);

  return (
    <div className="p-8" data-testid="admin-reviews-page">
      <div className="mb-6">
        <div className="font-mono text-xs text-[#FF3B30] tracking-widest">MODERATION</div>
        <h1 className="font-display text-5xl tracking-tighter mt-2">REVIEWS</h1>
      </div>
      <div className="space-y-3">
        {reviews.map((r) => (
          <div key={r.id} className="border border-black/10 bg-white p-4 grid md:grid-cols-[1fr_auto] gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="font-display tracking-widest">{r.user_name.toUpperCase()}</span>
                <span className="flex">{[1,2,3,4,5].map((n) => <Star key={n} size={12} className={n <= r.rating ? "fill-[#FF3B30] text-[#FF3B30]" : "text-black/20"} />)}</span>
                {r.approved ? <span className="text-[10px] font-mono text-[#FF3B30]">APPROVED</span> : <span className="text-[10px] font-mono text-yellow-400">PENDING</span>}
              </div>
              <div className="font-display tracking-tight">{r.title}</div>
              <div className="text-sm text-black/70 mt-1">{r.body}</div>
              <div className="text-[10px] font-mono text-black/40 mt-2">PRODUCT: {r.product_id.slice(0,8)} · {new Date(r.created_at).toLocaleString()}</div>
            </div>
            <div className="flex md:flex-col gap-2">
              {!r.approved && (
                <button onClick={async () => { await api.post(`/admin/reviews/${r.id}/approve`); load(); }} className="border border-[#FF3B30] text-[#FF3B30] px-3 py-2 text-xs font-display tracking-widest inline-flex items-center gap-1"><Check size={12} /> APPROVE</button>
              )}
              <button onClick={async () => { if (window.confirm("Delete review?")) { await api.delete(`/admin/reviews/${r.id}`); load(); } }} className="border border-black/30 text-black/60 hover:text-[#FF3B30] px-3 py-2 text-xs font-display tracking-widest inline-flex items-center gap-1"><Trash2 size={12} /> DELETE</button>
            </div>
          </div>
        ))}
        {!reviews.length && <div className="text-black/40 p-12 text-center font-mono text-xs border border-black/10">NO REVIEWS YET</div>}
      </div>
    </div>
  );
}
